import React from "react";
import PropTypes from "prop-types";
import Styled from "styled-components";
import { FormHelperText, TextField, Typography } from "@material-ui/core";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import Button from "../../waybee-ui/Button";
import SupportContact from "./SupportContact";

const Title = Styled.h3`
  font-size: 28px;
  font-weight: 300;
  color: #00303b;
  margin: 16px 0 12px;
  line-height: 1.43;
`;

const Form = Styled.form`
  width: 100%;
`;

function ForgotPassword(props) {
  const {
    closeForgotPassword,
    supportPhone,
    supportEmail,
    identifier,
    onChangeIdentifier,
    onSubmit,
    loading,
    error,
    onGoToReset
  } = props;
  const { t } = useTranslation();

  return (
    <>
      <Button
        color="secondary"
        startIcon={<ArrowBackIcon />}
        size="large"
        to="/"
        onClick={closeForgotPassword}
      />
      <Title level={6} gutterBottom>
        {t("login.forgotTitle")}
      </Title>
      <Typography variant="subtitle1" gutterBottom>
        {t("login.forgotHint")}
      </Typography>
      <Form
        noValidate
        onSubmit={e => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <TextField
          margin="normal"
          required
          fullWidth
          id="identifier"
          label={t("login.identifier")}
          name="identifier"
          autoComplete="username"
          autoFocus
          value={identifier}
          onChange={onChangeIdentifier}
          error={!!error}
        />
        {error ? <FormHelperText error>{error}</FormHelperText> : null}
        <Button
          className="main-button"
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? t("login.forgotSubmitting") : t("login.forgotSubmit")}
        </Button>
      </Form>
      <Button
        color="secondary"
        size="lg"
        onClick={onGoToReset}
        style={{ marginTop: 8 }}
      >
        {t("login.alreadyHaveToken")}
      </Button>
      <SupportContact phone={supportPhone} email={supportEmail} />
    </>
  );
}

ForgotPassword.propTypes = {
  closeForgotPassword: PropTypes.func.isRequired,
  supportPhone: PropTypes.string,
  supportEmail: PropTypes.string,
  identifier: PropTypes.string.isRequired,
  onChangeIdentifier: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
  onGoToReset: PropTypes.func.isRequired
};

ForgotPassword.defaultProps = {
  supportPhone: "",
  supportEmail: "",
  loading: false,
  error: ""
};

export default ForgotPassword;
